// extracted by mini-css-extract-plugin
export default {"gradient-bg5":"shareUrl__gradient-bg5__Lws0F","searchFooter":"shareUrl__searchFooter__dp3f0"};